import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { changePassword } from "./cognito";
import { Box, Stack, Typography, useColorScheme } from "@mui/material";
import MainInput from "../forms/main_input";
import { Constants } from "../../utils/constants";
import MainButton from "../buttons/main_button";
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';

function ChangePassword({ authStore }) {
  const { mode } = useColorScheme();
  const currentMode = mode || "system";
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");

  const [currentPassword, setCurrentPassword] = useState("");

  const onFinish = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    if (!currentPassword || !newPassword || !newPassword2) {
      setError("Please fill in all fields.");
      setSubmitting(false);
      return;
    }
    if (newPassword !== newPassword2) {
      setError("Password mismatch");
      setSubmitting(false);
      return;
    }
    try {
      await changePassword(currentPassword, newPassword);
      setSuccess("Password changed successfully.");
    } catch (e) {
      setError(e.message);
    }
    setSubmitting(false);
  };

  return (
    <Stack>
      {success ? (
        <Typography sx={{ color: Constants.Colors.success,
          fontWeight: Constants.Styles.fontWeight.normal,
          fontSize: Constants.Styles.fontSize.sm,
          lineHeight: Constants.Styles.lineHeight.sm,
         }}>{success}</Typography>
      ) : (
        <Box
          component={"form"}
          noValidate
          onSubmit={onFinish}
          sx={{
            maxWidth: 400,
          }}
        >
          <Stack
            spacing={`calc(${Constants.Styles.spacing} * 5)`}
          >
            <Box>
              <Typography sx={{
                fontWeight: Constants.Styles.fontWeight.medium,
                fontSize: Constants.Styles.fontSize.lg,
                lineHeight: Constants.Styles.lineHeight.lg,
              }}>Password</Typography>
              <Typography
                sx={{
                  fontWeight: Constants.Styles.fontWeight.medium,
                  fontSize: Constants.Styles.fontSize.sm,
                  lineHeight: Constants.Styles.lineHeight.sm,
                  color: Constants.Colors.light.mutedForeground,
                  mt: "0.5rem",
                }}
              >
                Update your account password
              </Typography>
            </Box>
            <Stack
              spacing={"0.5rem"}
            >
              <Typography
                sx={{
                  fontWeight: Constants.Styles.fontWeight.medium,
                  fontSize: Constants.Styles.fontSize.sm,
                  lineHeight: Constants.Styles.lineHeight.sm,
                }}
              >Current password</Typography>
              <MainInput
                name="currentPassword"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                isSecure={true}
                error={error != ""}
              />
            </Stack>
            <Stack
              spacing={"0.5rem"}
            >
              <Typography
                sx={{
                  fontWeight: Constants.Styles.fontWeight.medium,
                  fontSize: Constants.Styles.fontSize.sm,
                  lineHeight: Constants.Styles.lineHeight.sm,
                }}
              >New password</Typography>
              <MainInput
                name="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                isSecure={true}
                error={error != ""}
              />
            </Stack>
            <Stack
              spacing={"0.5rem"}
            >
              <Typography
                sx={{
                  fontWeight: Constants.Styles.fontWeight.medium,
                  fontSize: Constants.Styles.fontSize.sm,
                  lineHeight: Constants.Styles.lineHeight.sm,
                }}
              >Confirm New password</Typography>
              <MainInput
                name="newPassword2"
                value={newPassword2}
                onChange={(e) => setNewPassword2(e.target.value)}
                isSecure={true}
                error={error != ""}
              />
            </Stack>
            {error && <Typography
              sx={{
                color: Constants.Colors[currentMode].destructive,
                fontWeight: Constants.Styles.fontWeight.normal,
                fontSize: Constants.Styles.fontSize.sm,
                lineHeight: Constants.Styles.lineHeight.sm,
              }}
            >{error}</Typography>}
            <Box>
              <MainButton
                text={"Update Password"}
                type="submit"
                isSubmitting={submitting}
                size="medium"
                preIcon={<VpnKeyOutlinedIcon />}
              />
            </Box>
          </Stack>
        </Box>
      )}
    </Stack>
  );
}

export default observer(ChangePassword);
